import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import { BackupJobType, RestoreJob, type BackupJob, type ScanJob } from '@repo/api-gw-sdk';
import { useTemporalWorkflowUrl } from '@/utils/temporalLink';
import TemporalIcon from '../../../public/statics/images/apps/temporal.png';
import { CopyToClipboardWrapper } from '../buttons/copyToClipboardButton';
import { CircleImage } from '../shared/circleImage';
import { TextLink } from '../shared/textLink';
export const TemporalLinkField = t0 => {
  const $ = _c(17);
  const {
    entity
  } = t0;
  const temporalWorkflowUrl = useTemporalWorkflowUrl();
  let t1;
  if ($[0] !== entity) {
    t1 = () => {
      const fromJob = entity.jobExecutionDetails.workflowNamespace?.trim();
      if (fromJob) {
        return fromJob;
      }
      if (entity instanceof RestoreJob) {
        return "restore";
      }
      return "inventory";
    };
    $[0] = entity;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getTemporalNamespace = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [BackupJobType.AwsDynamoDbBackupFull, BackupJobType.AwsDynamoDbBackupFullExport, BackupJobType.AtlasMongodbClusterBackupFull, BackupJobType.AwsKeyspacesBackupFull];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const fullScanJobTypes = t2;
  let t3;
  if ($[3] !== entity) {
    t3 = () => {
      const jobId = entity.jobExecutionDetails.jobId;
      if ("backupType" in entity && entity.backupType && fullScanJobTypes.includes(entity.backupType)) {
        return `${jobId}${encodeURIComponent("/FullScan")}`;
      }
      return jobId;
    };
    $[3] = entity;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const getWorkflowId = t3;
  const t4 = entity.jobExecutionDetails.jobId;
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      alignItems: "center",
      gap: "8px"
    };
    t6 = <CircleImage src={TemporalIcon} alt="temporal" />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== getTemporalNamespace || $[8] !== getWorkflowId || $[9] !== temporalWorkflowUrl) {
    t7 = temporalWorkflowUrl(getTemporalNamespace(), getWorkflowId());
    $[7] = getTemporalNamespace;
    $[8] = getWorkflowId;
    $[9] = temporalWorkflowUrl;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== entity.jobExecutionDetails.jobId || $[12] !== t7) {
    t8 = <Stack direction="row" sx={t5}>{t6}<TextLink target="_blank" href={t7}>{entity.jobExecutionDetails.jobId}</TextLink></Stack>;
    $[11] = entity.jobExecutionDetails.jobId;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== entity.jobExecutionDetails.jobId || $[15] !== t8) {
    t9 = <CopyToClipboardWrapper textToCopy={t4}>{t8}</CopyToClipboardWrapper>;
    $[14] = entity.jobExecutionDetails.jobId;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};